import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'react';
import { combineReducers } from 'redux';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createReducerManager(initialReducers) {
  // Create an object which maps keys to reducers
  var reducers = _objectSpread({}, initialReducers); // Create the initial combinedReducer


  var combinedReducer = combineReducers(reducers); // An array which is used to delete state keys when reducers are removed

  var keysToRemove = [];
  return {
    getReducerMap: function getReducerMap() {
      return reducers;
    },
    // The root reducer function exposed by this object
    // This will be passed to the store
    reduce: function reduce(state, action) {
      // If any reducers have been removed, clean up their state first
      if (keysToRemove.length > 0) {
        state = _objectSpread({}, state);

        var _iterator = _createForOfIteratorHelper(keysToRemove),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            delete state[key];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        keysToRemove = [];
      } // Delegate to the combined reducer


      return combinedReducer(state, action);
    },
    // Adds a new reducer with the specified key
    add: function add(key, reducer) {
      if (!key || reducers[key]) {
        return;
      } // Add the reducer to the reducer mapping


      reducers[key] = reducer; // Generate a new combined reducer

      combinedReducer = combineReducers(reducers);
    },
    // Removes a reducer with the specified key
    remove: function remove(key) {
      if (!key || !reducers[key]) {
        return;
      } // Remove it from the reducer mapping


      delete reducers[key]; // Add the key to the list of keys to clean up

      keysToRemove.push(key); // Generate a new combined reducer

      combinedReducer = combineReducers(reducers);
    }
  };
}

export { createReducerManager as default };
